"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tablesWithPublishedOnField = exports.tablesWithStatusField = void 0;
exports.tablesWithStatusField = [
    'content-hub-articles',
    'just-cabins',
    'news',
    'ships',
    'unittest',
    'campaign-lists',
];
exports.tablesWithPublishedOnField = ['news'];
//# sourceMappingURL=tableDefintions.js.map